export const createTimeZoneInfo = (timeZone: string): { town: string; gmt: string } => {
  const town = timeZone.split('/')[1].replace(/_/g, ' ');
  const timeZoneOffset = new Date().getTimezoneOffset();

  const gmt = timeZoneOffset === 0 ? ' 0' : `${timeZoneOffset > 0 ? '-' : '+'} ${Math.abs(timeZoneOffset / 60)}`;

  return { town, gmt };
};
